module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "eventEdit-modal view dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.cancelEdit
    }
  }, [(_vm.getIsCreatSingleEvent) ? _c('div', {
    staticClass: "fs-large mt-4 mb-3 text-center",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      Create New Event\n    ")]) : _c('div', {
    staticClass: "fs-large mt-4 mb-3 text-center",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.getSelectedEvent.product.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "eventEditBody d-flex",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.isloadingEvent) ? _c('div', {
    staticClass: "text-center p-5"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('div', {
    staticClass: "col-md-3 bg-lighter darker font-weight-600 px-0 flexGrow1"
  }, [_c('ul', {
    staticClass: "pt-1"
  }, _vm._l((_vm.leftButtons), function(button) {
    return _c('li', {
      staticClass: "py-3 pl-3 pointer",
      class: {
        'bg-light': button.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectLeftButton(button)
        }
      }
    }, [_vm._v(_vm._s(button.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c(_vm.activeArea, {
    tag: "div",
    staticClass: "pb-4",
    attrs: {
      "validations": _vm.$v
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('footerButtons', {
    attrs: {
      "validations": _vm.$v
    },
    on: {
      "cancelEdit": _vm.cancelEdit
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-49b1184e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b1184e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit.vue
// module id = 964
// module chunks = 0